import { Typography } from "@mui/material";

export const SubSectionHeader = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle: string;
}) => {
  return (
    <>
      <Typography variant="h6" fontWeight={700}>
        {title}
      </Typography>
      <Typography variant="subtitle1" sx={{ color: "#737373" }}>
        {subtitle}
      </Typography>
    </>
  );
};
